import "./assets/css/App.css";
import "../../assets/css/toolkit.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";

import PropTypes from "prop-types";
// import { ConfigProvider } from "antd";
import { isMobile, isDesktop } from "react-device-detect";
import { createContext, useContext, useMemo } from "react";

// ToolkitContext to keep the latest state
const ToolkitContext = createContext(null);

export const useToolkitContext = () => {
  const context = useContext(ToolkitContext);

  if (!context) throw new Error("useToolkitContext context must be use inside ToolkitProvider");

  return context;
};

ToolkitProvider.propTypes = {
  children: PropTypes.node,
};

export default function ToolkitProvider({ children }) {
  const memoizedValue = useMemo(() => ({ isMobile, isDesktop }), []);

  return (
    <ToolkitContext.Provider value={memoizedValue}>
      {/* <ConfigProvider
        theme={{
          token: {
            borderRadius: 6,
            controlHeight: 36,
            colorLink: "#2cbfca",
            colorPrimary: "#2cbfca",
          },
          components: {
            Button: { colorPrimary: "#2cbfca" },
            Table: { rowHoverBg: "#f3f9fa" },
          },
        }}
      > */}
      {children}
      {/* </ConfigProvider> */}
    </ToolkitContext.Provider>
  );
}
